export default {
  name: "ConfirmDialog",
  props: {
    text: {
      required: true,
      type: String,
    },

  },
  methods: {
    confirmAction() {
      this.$emit("confirmAction");
    },

    recuseAction() {
      this.$emit("recuseAction");
    },
  },
};
